import * as i0 from '@angular/core';
import { ElementRef, NgZone, Directive, Inject, Output, NgModule } from '@angular/core';
import { tuiTypedFromEvent, tuiZoneOptimized } from '@taiga-ui/cdk/observables';
import { tuiIsNativeFocused } from '@taiga-ui/cdk/utils/focus';
import { merge } from 'rxjs';
import { map, startWith, distinctUntilChanged, skip } from 'rxjs/operators';

/**
 * Directive to monitor focus/blur status, works with focusIn/focus-out
 * instead of focus/blur to sync events order with Internet Explorer and
 * other focus related directives that require bubbling
 */
class TuiFocusedDirective {
    constructor({ nativeElement }, ngZone) {
        this.tuiFocusedChange = merge(tuiTypedFromEvent(nativeElement, 'focusin'), tuiTypedFromEvent(nativeElement, 'focusout')).pipe(map(() => tuiIsNativeFocused(nativeElement)), startWith(false), distinctUntilChanged(), skip(1), tuiZoneOptimized(ngZone));
    }
}
TuiFocusedDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFocusedDirective, deps: [{ token: ElementRef }, { token: NgZone }], target: i0.ɵɵFactoryTarget.Directive });
TuiFocusedDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: TuiFocusedDirective, selector: "[tuiFocusedChange]", outputs: { tuiFocusedChange: "tuiFocusedChange" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFocusedDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[tuiFocusedChange]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef, decorators: [{
                    type: Inject,
                    args: [ElementRef]
                }] }, { type: i0.NgZone, decorators: [{
                    type: Inject,
                    args: [NgZone]
                }] }]; }, propDecorators: { tuiFocusedChange: [{
                type: Output
            }] } });

class TuiFocusedModule {
}
TuiFocusedModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFocusedModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TuiFocusedModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFocusedModule, declarations: [TuiFocusedDirective], exports: [TuiFocusedDirective] });
TuiFocusedModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFocusedModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFocusedModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TuiFocusedDirective],
                    exports: [TuiFocusedDirective],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TuiFocusedDirective, TuiFocusedModule };
